export interface ScipioneRuntimeConfig {
  apiBaseUrl?: string;
}

declare global {
  interface Window {
    SCIPIONE_CONFIG?: ScipioneRuntimeConfig;
  }
}

export function apiUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const apiBaseUrl = window.SCIPIONE_CONFIG?.apiBaseUrl?.trim();
  if (!apiBaseUrl) {
    return normalizedPath;
  }

  return `${apiBaseUrl.replace(/\/+$/, '')}${normalizedPath}`;
}

export function resolveApiAssets<T>(value: T): T {
  if (typeof value === 'string' && value.startsWith('/api/')) {
    return apiUrl(value) as T;
  }
  if (Array.isArray(value)) {
    return value.map(item => resolveApiAssets(item)) as T;
  }
  if (value && typeof value === 'object') {
    for (const [key, item] of Object.entries(value)) {
      (value as Record<string, unknown>)[key] = resolveApiAssets(item);
    }
  }
  return value;
}
